import { render } from "./RichCardItem.vue?vue&type=template&id=3b21f621&scoped=true"
import script from "./RichCardItem.vue?vue&type=script&lang=js"
export * from "./RichCardItem.vue?vue&type=script&lang=js"

import "./RichCardItem.vue?vue&type=style&index=0&id=3b21f621&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b21f621"]])

export default __exports__